var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3107 18.7743C9.93996 19.2934 9.2214 19.3458 8.78671 18.8858L8.69668 18.7905C8.3466 18.4199 8.30092 17.8358 8.58869 17.4093L13.0408 11.966L8.58877 6.59028C8.301 6.16384 8.34667 5.57968 8.69676 5.20912L8.7868 5.11382C9.22148 4.6537 9.94003 4.70626 10.3108 5.2253L15.3951 11.3194C15.6683 11.702 15.6683 12.2301 15.3951 12.6125L10.3107 18.7743Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIcon);
export default __webpack_public_path__ + "static/media/chevron_right_icon.4b57fdee730df19385eadb17bdaa5a89.svg";
export { ForwardRef as ReactComponent };